const footballOrHockey = r => ['football', 'hockey'].includes(r.sport)
const hasStages = r =>
  [
    'football',
    'hockey',
    'csgo',
    'lol',
    'e_football',
    'basket',
  ].includes(r.sport)
const fields = [{
  normal: 'bout',
  type: 'number',
}, {
  normal: 'tag',
  type: 'text',
}, {
  normal: 'name',
  type: 'text',
  if: r => r.hasTag('nonDuel'),
}, {
  normal: 'groupStage',
  type: 'text',
  if: hasStages,
}, {
  normal: 'playOffStage',
  type: 'text',
  if: hasStages,
}, {
  normal: 'points',
  type: 'number',
  if: hasStages,
}, {
  normal: 'customDifficultyHome',
  type: 'number',
  if: footballOrHockey,
}, {
  normal: 'customDifficultyAway',
  type: 'number',
  if: footballOrHockey,
}, {
  normal: 'uid',
  type: 'number',
  if: r => r.sport === 'dota2'
}, {
  normal: 'source',
  type: 'number',
  if: r => r.sport === 'dota2'
}, {
  normal: 'leagueId',
  type: 'number',
  if: r => r.sport === 'dota2'
}, {
  normal: 'seriesId',
  type: 'number',
  if: r => r.sport === 'dota2'
}, {
  normal: 'difficulty',
  type: 'number' ,
  if: r => r.hasTag('crossCountry')
}, {
  normal: 'distance',
  type: 'number' ,
  if: r => r.hasTag('crossCountry')
}, {
  normal: 'finishLine',
  type: 'number' ,
  if: r => r.hasTag('crossCountry')
}, {
  normal: 'startLocation',
  type: 'text' ,
  if: r => r.hasTag('crossCountry')
}, {
  normal: 'endLocation',
  type: 'text' ,
  if: r => r.hasTag('crossCountry')
}, {
  normal: 'periods',
  name: 'races',
  type: 'number',
  if: r => r.hasTag('periods') && r.hasTag('racing'),
}, {
  normal: 'periods',
  name: 'innings',
  type: 'number',
  if: r => r.sport === 'cricket',
}, {
  normal: 'periods',
  type: 'number',
  if: r => r.hasTag('periods') && !r.hasTag('racing') && r.sport !== 'cricket',
}, {
  normal: 'distance',
  name: 'hillrecord',
  type: 'number',
  if: r => r.sport === 'ski_jump',
}, {
  normal: 'distance',
  name: 'overs',
  type: 'number',
  if: r => r.sport === 'cricket',
}, {
  normal: 'location',
  type: 'text',
  if: r => r.sport === 'golf',
}, {
  normal: 'venue',
  type: 'text',
  if: r => r.sport === 'golf',
}]

function customFields(rules) {
  if(!rules) return []
  return fields.filter(rule => !rule.if || rule.if(rules))
}

export default customFields
